import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import store from 'redux/store';
import Router from 'utils/routing';
import MainContainer from 'modules/shared/common/containers/MainContainer';
import themeData from 'utils/theme/themeData';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={themeData}>
          <MainContainer>
            <Router />
          </MainContainer>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
